import { createScopedInstance } from '@citrite/translate';
import { languages } from './locales/';
const instance = createScopedInstance({
    resources: languages,
    namespace: 'domino-builder',
});
export const { t } = instance;
//# sourceMappingURL=translate.js.map